const triggers = document.querySelectorAll('.js-tab-trigger');
const contents = document.querySelectorAll('.js-tab-body');
const ACTIVE_CLASS = 'is-active';
const OPEN_CLASS = 'is-open';

const toggleClass = (trigger) => {
  const target = document.getElementById(trigger.getAttribute('data-target'));

  contents.forEach(target => {
    target.classList.remove(OPEN_CLASS);
  });

  triggers.forEach(trigger => {
    trigger.classList.remove(ACTIVE_CLASS);
  });

  trigger.classList.add(ACTIVE_CLASS);
  target.classList.add(OPEN_CLASS);
};

const clickHandler = (e) => {
  e.preventDefault();
  const trigger = e.currentTarget;
  toggleClass(trigger);
};

const pageIn = () => {
  const searchParams = new URLSearchParams(window.location.search);

  let index;

  if (searchParams.has('tabIndex')) {
    index = Number(searchParams.get('tabIndex')) - 1;

  } else {
    index = 0;
  }

  const trigger = triggers[index];
  toggleClass(trigger);
};


const init = () => {

  if (triggers.length === 0) return;
  pageIn();
  triggers.forEach(trigger => {
    trigger.addEventListener('click', clickHandler);
  });
};

export default () => {
  init();
};
